import { Container } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledContainer = styled(Container)`
	padding: 0;
	box-sizing: border-box;
`
